export var ValueRole;
(function (ValueRole) {
    // Due to TS limitations, we cannot reuse values from `Tag`
    ValueRole["Child"] = "CHIL";
    ValueRole["Husband"] = "HUSB";
    ValueRole["Wife"] = "WIFE";
    ValueRole["Mother"] = "MOTH";
    ValueRole["Father"] = "FATH";
    ValueRole["Spouse"] = "SPOU";
})(ValueRole || (ValueRole = {}));
//# sourceMappingURL=ValueRole.js.map